import React, { useCallback } from 'react'

import {
  clearSearchAndFetch,
  selectSearchPage,
  setFilters,
} from '@disco/state-management/reducers/search-page'

import FilterBar from './filter-bar'

import { useDispatch, useSelector } from 'hooks/use-redux'

import type { FilterState } from 'types/filter-page'

/** Binds the shared filter bar to the search page's own state. */
const SearchFilters = (): React.ReactNode | null => {
  const dispatch = useDispatch()
  const { filters, query } = useSelector(selectSearchPage)

  const handleFiltersChange = useCallback(
    (value: FilterState[]) => dispatch(setFilters(value)),
    [dispatch],
  )
  const handleClearAll = useCallback(
    (clearedFilters: FilterState[]) => {
      void dispatch(clearSearchAndFetch(clearedFilters))
    },
    [dispatch],
  )

  return (
    <FilterBar
      filters={filters}
      hasQuery={!!query}
      onChange={handleFiltersChange}
      onClearAll={handleClearAll}
    />
  )
}

export default SearchFilters
